import { useSelector } from 'react-redux';
import './sidebar/unauthorized.css';
import Header from './header/index';

const Unauthorized = () => {
  const user = useSelector((state: any) => state.auth?.user);

  const hasPermission =
    user?.roles?.length > 0 || user?.permissions?.length > 0;

  if (hasPermission) {
    return <h1>Sidebar with Access</h1>;
  }


  return (
    <>
    <Header />

    <div className="no-permission-container">
      <div className="no-permission-card">
       
        <h2 className="no-permission-title">Access Denied</h2>
        <p className="no-permission-text">
          You don't have permission to access any pages. Please contact your
          administrator for access.
        </p>
      </div>
    </div>
    </>
    
  );
};

export default Unauthorized;
